/* eslint-disable complexity */
import {
  ADD_TO_BAG,
  ADD_TO_BAG_ERROR,
  RESET_BUTTON,
} from "../../actions/PremierProposition";

const initialState = {
  premierSubscriptionAdded: false,
};

const PremierProposition = (state = initialState, action) => {
  switch (action.type) {
    case ADD_TO_BAG: {
      return Object.assign({}, state, {
        premierSubscriptionAdded: true,
        errorMessage: undefined,
      });
    }
    case ADD_TO_BAG_ERROR: {
      return Object.assign({}, state, {
        premierSubscriptionAdded: false,
        errorMessage:
          typeof action.error === "object"
            ? action.error[0] && action.error[0].userMessage
            : action.error,
      });
    }
    case RESET_BUTTON: {
      return Object.assign({}, state, {
        premierSubscriptionAdded: false,
      });
    }
    default: {
      return state;
    }
  }
};

export default PremierProposition;
